import React from 'react';

const StatusConnected: React.FC<React.PropsWithChildren> = () => (
  <>
    <circle cx="4" cy="6" r="4" />
  </>
);

export default StatusConnected;
